import {
  useLocation,
  useNavigate,
  useSearchParams as useRRSearchParams,
} from 'react-router-dom'

/** Next.js-style router. */
export function useRouter() {
  const navigate = useNavigate()
  return {
    push: (to: string) => navigate(to),
    replace: (to: string) => navigate(to, { replace: true }),
    back: () => navigate(-1),
  }
}

/** Next.js-style search params (single URLSearchParams, not a tuple). */
export function useSearchParams() {
  const [params] = useRRSearchParams()
  return params
}

/** Next.js-style pathname (react-router v7 has no usePathname). */
export function usePathname() {
  return useLocation().pathname
}

export { useNavigate }
